import React from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";

import OrganizationDetail from "./OrganizationDetail/OrganizationDetail";

export default function OrganizationsDetail(props: {
  organizations: IOrganization[];
}): React.JSX.Element {
  /**
   * A detailed view of organizations (belonging to a BAG object).
   * If there is only one organization, it will be displayed directly.
   * If there are multiple organizations, a tabbed interface will be used to switch between them.
   */
  if (props.organizations.length === 1) {
    // If there is only one organization, display it directly.
    return <OrganizationDetail organization={props.organizations[0]} />;
  } else {
    // If there are multiple organizations, use a tabbed interface.
    return (
      <Tab.Container defaultActiveKey={props.organizations[0].id}>
        <Row>
          <Col sm={4}>
            <Nav variant="pills" className="flex-column">
              {props.organizations.map((organization) => (
                <Nav.Item
                  className="w-100"
                  key={`tab-item-org-${organization.id}`}
                >
                  <Nav.Link
                    as="button"
                    title={organization.name}
                    eventKey={organization.id}
                    className="w-100 py-1 px-3 mb-1 text-truncate btn btn-outline-primary btn-sm"
                  >
                    {organization.name}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
          <Col sm={8}>
            <Tab.Content>
              {props.organizations.map((organization) => (
                <Tab.Pane
                  eventKey={organization.id}
                  key={`tab-pane-org-${organization.id}`}
                >
                  <OrganizationDetail organization={organization} />
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    );
  }
}
